import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import selectOptions from '../../../../../../text/selectOptions';
import { TextField, SelectField } from './../../../../../../components/fields';
import { required } from './../../../../../../utilities/validation';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { DocumentInfo } from '../../../../../../utilities/documentTypes';
import { getAdmin, setProgressionProperties } from '../../../../../../reducers/onboarding';
import DocBug from './../../../../../../components/docBug';
import { updateUserProfile } from '../../../../../../reducers/identity';
import User from '../../../../../../models/user';
import { maskSSN } from '../../../../../../utilities/string';
import mixpanel from 'mixpanel-browser';

class W4Step extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    submit(values, onComplete) {
        const { profile, updateUserProfile, personalInformation, setProgressionProperties } = this.props;
        const { w4_fields } = values;

        updateUserProfile(new User({ ...profile, w4_fields }), () => {
            setProgressionProperties({ personalInformation: { ...personalInformation, w4_fields } });
            onComplete();
        });
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'W4Step' } });

        const { profile, admin, client, getAdmin, setProgressionProperties } = this.props;
        if (!admin) {
            getAdmin(client.admin_id);
        }

        let personalInformation = {
            firstName: profile.first_name,
            middleName: profile.middle_name,
            lastName: profile.last_name,
            email: profile.email,
            phoneNumber: profile.phone,
            dateOfBirth: profile.birthday_date,
            socialSecurityNumber: maskSSN(profile.ssn_bg_check),
            emergency_name: profile.emergency_name,
            emergency_email: profile.emergency_email,
            emergency_phone: profile.emergency_phone,
            emergency_relationship: profile.emergency_relationship,
            w4_fields: profile.w4_fields,
            i9_fields: profile.i9_fields
        };

        let dateOfBirth = { day: null, month: null, year: null };
        if (personalInformation.dateOfBirth) {
            let date = new Date(personalInformation.dateOfBirth + 'T00:00:00');
            dateOfBirth = {
                date: personalInformation.dateOfBirth,
                day: isNaN(date.getDate()) ? null : date.getDate(),
                month: isNaN(date.getMonth()) ? null : date.getMonth() + 1,
                year: isNaN(date.getFullYear()) ? null : date.getFullYear()
            };
        }

        setProgressionProperties({ personalInformation: { ...personalInformation, dateOfBirth } });
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, admin } = this.props;
        if (!admin) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'w4.intro'}
                            defaultMessage={
                                'The following information will be used to determine your tax withholding.  If you need the instructions, check the PDF below.'
                            }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-xs-12">
                        <Field
                            name="w4_fields.filingStatus"
                            validate={required}
                            component={SelectField}
                            options={selectOptions.filingStatus}
                            placeholder={messages.w4FillingStatus}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-xs-12">
                        <Field name="w4_fields.totalAllowances" validate={required} component={TextField} placeholder={messages.w4TotalAllowances} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-xs-12">
                        <Field name="w4_fields.additionalWithholding" component={TextField} placeholder={messages.w4AdditionalWithholding} />
                    </div>
                </div>

                <DocBug docType={DocumentInfo.types.ADMIN_W4.docType} adminId={admin && admin.id} />

                <WizardButtons disabled={submitting} back={{ action: back }} />
            </form>
        );
    }
}

W4Step = reduxForm(formSettings)(W4Step);

const mapStateToProps = state => {
    let personalInformation = state.onboarding.progression.personalInformation;

    return {
        profile: state.identity.profile,
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        personalInformation,
        initialValues: personalInformation ? { w4_fields: personalInformation.w4_fields } : undefined
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            updateUserProfile: updateUserProfile,
            setProgressionProperties: setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(W4Step);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/w4Step.jsx